import React from 'react';
import Parser from "html-react-parser";

const TermsOfService = () => {
  const datas = [
    {
      id: 1,
      title: 'Article 1 (Purpose)',
      contents: `These Terms of Service ("Terms") define the rights, obligations, and responsibilities between HERINGS Inc. ("the Company"), the operator of the Healiary Global service ("the Service"), and individuals ("Members") who use the Service, as well as matters related to user-generated content and postings.`
    },
    {
      id: 2,
      title: 'Article 2 (Effect and Amendment of the Terms)',
      contents: `① These Terms apply to all Members who agree to them when using the Service.<br/>
      ② The Company may amend these Terms in accordance with applicable laws, including consumer protection and electronic commerce regulations, when deemed necessary.<br/>
      ③ Any amendments will be announced on the Service's main page or website at least 7 days before they take effect. For amendments that materially affect Members or are unfavorable, notice will be provided at least 30 days in advance via announcements or individual notifications (e.g., email, SMS, or in-app pop-up).<br/>
      ④ Continued use of the Service after the effective date of amended Terms constitutes acceptance of the revised Terms. Members who do not agree must stop using the Service and may terminate their account.<br/>
      ⑤ Matters not covered by these Terms shall be governed by applicable laws and generally accepted commercial practices.`
    },
    {
      id: 3,
      title: 'Article 3 (Definitions)',
      contents: `① Terms used herein have the following meanings:<br/>
      1. <strong>Service</strong>: A digital health management platform provided via mobile application, which may receive or process data from wearable devices, IoT devices, or medical devices to deliver personalized health information and recommendations.<br/>
      2. <strong>Member</strong>: An individual who agrees to these Terms and has created an account to use the Service.<br/>
      3. <strong>Application</strong>: The Healiary Global mobile app available on Android and iOS that enables Members to access the Service.<br/>
      4. <strong>Personal Data</strong>: Information that identifies or can identify an individual, in accordance with applicable data protection laws (e.g., GDPR).<br/>
      5. <strong>Payment</strong>: Any monetary transaction made to access paid services or premium features.<br/>
      6. <strong>Subscription</strong>: A recurring or one-time paid plan that provides access to Healiary Global's premium features for a defined period.<br/>
      ② Terms not defined above shall follow the definitions provided in applicable laws or specific service policies.`
    },
    {
      id: 4,
      title: 'Article 4 (Formation of the Service Use Agreement)',
      contents: `① The service agreement is formed when an individual applies for membership and the Company accepts the application.<br/>
      ② The Company may refuse or delay approval if:<br/>
      1. Payment has not been completed or is invalid,<br/>
      2. False information was provided,<br/>
      3. Technical or operational constraints exist,<br/>
      4. The applicant previously violated Terms or was suspended,<br/>
      5. Legal or guardian consent requirements are not met,<br/>
      6. The applicant does not meet eligibility requirements.<br/>
      ③ Agreement to these Terms constitutes agreement to all related services operated by the Company under the Healiary Global platform.<br/>
      ④ The Company may restrict or limit access to certain regions based on licensing, legal, or operational factors.`
    },
    {
      id: 5,
      title: 'Article 5 (Application Installation)',
      contents: `Members must install the Healiary Global mobile app on a compatible device to use the Service.`
    },
    {
      id: 6,
      title: 'Article 6 (Termination of Agreement)',
      contents: `<strong>① By the Member:</strong><br/>
      1. Members may terminate their account at any time via the "Delete Account / Withdrawal" menu within the app. Deleting the app alone does not terminate membership.<br/>
      2. Subscription cancellations must be made separately through the respective app store (Google Play or App Store).<br/>
      3. Upon withdrawal, all points, credits, and benefits will be deleted and are non-recoverable.<br/>
      <strong>② By the Company:</strong><br/>
      1. The Company may terminate accounts if Members:<br/>
      a. Violate laws or these Terms,<br/>
      b. Interfere with service operations,<br/>
      c. Engage in fraudulent or unlawful activity,<br/>
      d. Reproduce or distribute copyrighted materials without authorization.<br/>
      2. The Company will notify Members of termination via email, in-app notice, or SMS.<br/>
      3. Upon termination, all benefits may be revoked, and re-registration may be restricted.`
    },
    {
      id: 7,
      title: 'Article 7 (Service Availability and Member Obligations)',
      contents: `① The Service is normally available 24 hours a day, except during maintenance or technical issues.<br/>
      ② The Company may suspend the Service temporarily for updates, security patches, or system checks.<br/>
      ③ Members must keep their contact and personal information up to date; the Company is not liable for any disadvantages caused by outdated information.<br/>
      ④ Service access may be limited on modified ("rooted" or "jailbroken") devices.<br/>
      ⑤ Standard data charges may apply when accessing the Service via mobile networks or overseas connections; such costs are borne by the Member.`
    },
    {
      id: 8,
      title: 'Article 8 (Restriction or Suspension of the Service)',
      contents: `① The Company may restrict or suspend part or all of the Service in cases of:<br/>
      1. System maintenance, upgrades, or repairs,<br/>
      2. Force majeure (e.g., natural disasters, power failures),<br/>
      3. Administrative orders or legal obligations,<br/>
      4. Business restructuring or technical difficulties.<br/>
      ② Members will be notified in advance whenever reasonably possible.<br/>
      ③ The Company shall not be liable for losses caused by suspension due to events beyond its control, except in cases of gross negligence or intentional misconduct.`
    },
    {
      id: 9,
      title: 'Article 9 (Provision of Information and Advertising)',
      contents: `① The Company may provide Members with information about updates, products, or promotional offers via the app, email, or SMS.<br/>
      ② Members may withdraw consent to marketing communications at any time.<br/>
      ③ The Company may display in-app advertisements. Use of third-party links or content is at the Member's discretion, and the Company is not responsible for third-party services.`
    },
    {
      id: 10,
      title: 'Article 10 (Paid Services and Subscriptions)',
      contents: `① Paid service agreements are established when a Member completes payment and the Company approves access.<br/>
      ② The terms of each paid plan (price, duration, and renewal) are displayed on the purchase page.<br/>
      ③ For App Store or Google Play payments, applicable store policies govern billing, cancellation, and refunds.<br/>
      ④ Data or mobile network fees incurred during use are billed by the Member's carrier.`
    },
    {
      id: 11,
      title: 'Article 11 (Recurring Subscription and Cancellation)',
      contents: `① Recurring subscriptions automatically renew at the end of each billing cycle unless cancelled.<br/>
      ② Cancellation can be managed through the respective app store's account settings.<br/>
      ③ The Company is not responsible for payment failures due to expired or invalid payment methods.<br/>
      ④ Refunds are handled in accordance with Apple App Store or Google Play policies.`
    },
    {
      id: 12,
      title: 'Article 12 (Member Conduct and Sanctions)',
      contents: `① The Company may take disciplinary action, including restriction, suspension, or termination, if a Member:<br/>
      1. Violates laws, public order, or these Terms,<br/>
      2. Harms other users,<br/>
      3. Uses the Service for unauthorized or commercial purposes.<br/>
      ② Members will be notified before action is taken, unless immediate action is required for security or operational reasons.`
    },
    {
      id: 13,
      title: 'Article 13 (Disclaimer)',
      contents: `The Company shall not be liable for damages arising from:<br/>
      1. Force majeure (e.g., natural disasters, emergencies),<br/>
      2. User negligence or misuse,<br/>
      3. Third-party system failures beyond the Company's control,<br/>
      4. Errors in information provided by third parties, or<br/>
      5. Events not caused by the Company's fault or negligence.`
    },
    {
      id: 14,
      title: 'Article 14 (Damages and Indemnification)',
      contents: `① Members may not reproduce, distribute, or commercially exploit content provided by the Service without prior written consent.<br/>
      ② Members are liable for any damages caused by their breach of these Terms or applicable laws.<br/>
      ③ If the Company faces claims from third parties due to a Member's unlawful conduct, the Member shall indemnify and hold the Company harmless.`
    },
    {
      id: 15,
      title: 'Article 15 (Linked Services)',
      contents: `The Service may contain links to third-party content or websites. The Company does not control and is not responsible for third-party services, transactions, or content.`
    },
    {
      id: 16,
      title: 'Article 16 (Health and Nutrition Disclaimer)',
      contents: `Information and content provided through the Service (including meal or diet recommendations) are for general health information only and do not constitute medical advice. Users with food allergies or medical conditions must verify all nutritional information before consumption. The Company is not liable for any injury, illness, or loss arising from the use of such information.`
    },
    {
      id: 17,
      title: 'Article 17 (Governing Law and Jurisdiction)',
      contents: `① These Terms are governed by the laws of the Grand Duchy of Luxembourg (for EU users) and the Republic of Korea (for others), without regard to conflict-of-law principles.<br/>
      ② Any dispute that cannot be resolved amicably shall be submitted to the competent court of Seoul, Republic of Korea, unless otherwise required by applicable law.<br/><br/>
      <strong>HERINGS Inc.</strong><br/>
      Email: herings@heringsglobal.com<br/>
      Website: <a href='https://heringsglobal.com' className='font-bold'>https://heringsglobal.com</a>`
    },
  ];

  return (
    <div className='text-gray2 keepAll select-text'>
      <h1 className='text-body3_700 text-gray_160 mb-4'>Healiary Global Terms of Service</h1>
      <p className='text-caption2_400 text-gray_120 mb-4'>Version: v1.0<br/>Effective Date: 2025-10-31</p>

      <ul>
        <h2 className='text-caption2_700 text-gray_160 mb-2'>Chapter 1. General Provisions</h2>
        {datas.slice(0, 3).map(data =>
          <li key={data.id} className='mb-2'>
            <h3 className='text-caption2_700 text-gray_160'>{data.title}</h3>
            <p className='text-caption2_400 text-gray_120'>{Parser(data.contents)}</p>
          </li>
        )}
      </ul>
      <ul>
        <h2 className='text-caption2_700 text-gray_160 mb-2'>Chapter 2. Service Agreement and Account Management</h2>
        {datas.slice(3, 6).map(data =>
          <li key={data.id} className='mb-2'>
            <h3 className='text-caption2_700 text-gray_160'>{data.title}</h3>
            <p className='text-caption2_400 text-gray_120'>{Parser(data.contents)}</p>
          </li>
        )}
      </ul>
      <ul>
        <h2 className='text-caption2_700 text-gray_160 mb-2'>Chapter 3. Use of the Service</h2>
        {datas.slice(6, 11).map(data =>
          <li key={data.id} className='mb-2'>
            <h3 className='text-caption2_700 text-gray_160'>{data.title}</h3>
            <p className='text-caption2_400 text-gray_120'>{Parser(data.contents)}</p>
          </li>
        )}
      </ul>
      <ul>
        <h2 className='text-caption2_700 text-gray_160 mb-2'>Chapter 4. Member Management and Protection</h2>
        {datas.slice(11, 12).map(data =>
          <li key={data.id} className='mb-2'>
            <h3 className='text-caption2_700 text-gray_160'>{data.title}</h3>
            <p className='text-caption2_400 text-gray_120'>{Parser(data.contents)}</p>
          </li>
        )}
      </ul>
      <ul>
        <h2 className='text-caption2_700 text-gray_160 mb-2'>Chapter 5. Limitation of Liability and Miscellaneous</h2>
        {datas.slice(12, 17).map(data =>
          <li key={data.id} className='mb-2'>
            <h3 className='text-caption2_700 text-gray_160'>{data.title}</h3>
            <p className='text-caption2_400 text-gray_120'>{Parser(data.contents)}</p>
          </li>
        )}
      </ul>
    </div>
  );
};

export default TermsOfService;
